module.exports = new __parcel__URL__("Green.98ed18c1.png").toString();